Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');
var coreComponentsShared = require('../../../shared');
var Context = require('../../Context.js');
var ResponsiveContext = require('../../ResponsiveContext.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"content":"side-panel__content_17vzp","withHeader":"side-panel__withHeader_17vzp","flex":"side-panel__flex_17vzp"};
require('./index.css');

var Content = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, dataTestId = _a.dataTestId;
    var _c = React.useContext(Context.ModalContext), contentRef = _c.contentRef, hasHeader = _c.hasHeader;
    var responsiveContext = React.useContext(ResponsiveContext.ResponsiveContext);
    return (React__default.default.createElement("div", { className: cn__default.default(styles.content, className, styles.flex, (_b = {},
            _b[styles.withHeader] = hasHeader,
            _b)), ref: contentRef, "data-test-id": dataTestId || coreComponentsShared.getDataTestId(responsiveContext === null || responsiveContext === void 0 ? void 0 : responsiveContext.dataTestId, 'content') }, children));
};

exports.Content = Content;
